/** @csi/table/QuickSearch */
define([
	"dojo/_base/lang",
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",

	"csi/action",
	"csi/card/_base",
	"csi/def/Action",
	"csi/html",
	"csi/xml",
	"csi/xml/Query",

	"dojo/text!./QuickSearch.html",

	"dijit/form/TextBox",
], function(lang, declare, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, csiAction, csiCard, Action, html, xml, Query, template) {

	const QUERY_DELAY = 1500;

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin], {
		baseClass: "csi-table-quick-search",
		templateString: template,

		/** @property {boolean} _searchNow - start next search immediately without delay */
		//_searchNow:  false,

		/** @property {Handle} _timeout - timeout handle from last request */
		//_timeout: null,

		/** @property {Object} view - table view */
		//view: null

		/**
		 * User input in quick search box
		 * @param {KeyboardEvent} 
		 */
		_onQuickSearchInput: function(ev) {
			_.defer(()=>{
				this._searchNow = !ev?.key || (ev.key === "Enter");
				const value = this.quickSearchEditorNode.textbox.value;
				html.setVisible(this.quickSearchClearNode, !!value);
				this._startSearch(value);
			});
		},

		/**
		 * clear quick search box
		 */
		_onQuickSearchClear: function() {
			this.quickSearchEditorNode.set("value", "");
			this._onQuickSearchInput();
		},

		/**
		 * Start search / set timeout
		 * @param {string} value 
		 */
		_startSearch: function(value) {
			const {_timeout, view} = this;

			if (_timeout) {
				// clear any timeout since we will have to search again
				window.clearTimeout(_timeout);
				this._timeout = null;
			}				
			this._timeout = window.setTimeout(() => {
				const store = view.store;
				if (value) {
					const quickSearchQuery = []
					const slimCardSpecs = csiCard.getAttributeCardSlimSpecs(store.typeNode);
					for (const spec of slimCardSpecs.attributeSpecs) {
						quickSearchQuery.push({
							key: (spec.querySpec.id === xml.FILTER_LOCALIZED_NAME) ? xml.ATTR_NAME : spec.queryKey, 
							value: xml.getServerMatchValue(value) || "*"
						});
					}
					view.quickSearchQuery = quickSearchQuery;
				} else {
					view.quickSearchQuery = null;
				}
				this.onChange();

			}, this._searchNow ? 0 : QUERY_DELAY);
			this._searchNow = false;
		},

	});

});